
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 查询云课堂列表
 * @returns
 */
export const getCloudClassRoom = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/CloudClassRoom`, {params: data})
}
/**
 * 查询云课堂详细 
 * @returns
 */
export const getCloudClassRoomDetail = (id: any) => {
    return axios.get(`${baseURL}/CloudClassRoom/${id}`)
}
/**
 * 获取云课堂推荐 
 * @returns
 */
export const getCloudClassrecommend = (id: any) => {
    return axios.get(`${baseURL}/CloudClassRoom/recommend?id=${id}`)
}
/**
 * 更新云课堂访问量 =
 * @returns
 */
export const putVisitsCount = (id: any) => {
    return axios.put(`${baseURL}/CloudClassRoom/${id}/VisitsCount`)
}

/**
 * 
 * @returns
 */
 export const getCloudClassRoomHomeList = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/CloudClassRoom/GetHomeList`, {params: data})
}
